// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/notificationbook/index.html
import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/notification/notificationActions";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
  toastOption,
} from "../../../../../_metronic/_helpers";
import * as uiHelpers from "../NotificationUIHelpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useNotificationUIContext } from "../NotificationUIContext";
import { NotificationDisableDialog } from "../notification-disable-dialog/NotificationDisableDialog";
import { RoleChecker } from "../../../../RoleChecker";
import { Link } from "react-router-dom";
import { ImagesModal } from "../../../../components/ImagesModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RESEND_NOTIF } from "../../_redux/notification/notificationCrud";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";

export function NotificationTable() {
  const allowDelete = RoleChecker("delete", "notification");
  const allowUpdate = RoleChecker("update", "notification");
  // notification UI Context
  const notificationUIContext = useNotificationUIContext();
  const notificationUIProps = useMemo(() => {
    return {
      ids: notificationUIContext.ids,
      setIds: notificationUIContext.setIds,
      queryParams: notificationUIContext.queryParams,
      setQueryParams: notificationUIContext.setQueryParams,
      openEditNotification: notificationUIContext.openEditNotification,
      // openDeleteNotificationDialog: notificationUIContext.openDeleteNotificationDialog,
    };
  }, [notificationUIContext]);

  const [resendNotif, { loading }] = useMutation(RESEND_NOTIF, {
    onCompleted: () => {
      toast.success("Berhasil mengirim ulang notifikasi", toastOption);
      dispatch(actions.fetchNotifications(notificationUIProps.queryParams));
    },
    onError: (err) => {
      console.log(err);
      toast.error("Gagal mengirim ulang notifikasi", toastOption);
    },
  });

  const resendFunction = (uuid) => {
    resendNotif({
      variables: {
        uuid: uuid,
      },
    });
  };

  const [showModal, setShowModal] = useState(false);
  const [rowId, setRowId] = useState();

  const [showModalImage, setShowModalImage] = useState(false);
  const [currentImages, setCurrentImages] = useState(null);

  useEffect(() => {
    setShowModalImage(Boolean(currentImages));
  }, [currentImages]);

  // Getting curret state of notification list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.notificationUser }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;

  // notification Redux state
  const dispatch = useDispatch();
  useEffect(() => {
    // clear selections list
    notificationUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchNotifications(notificationUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [
    {
      dataField: "title",
      text: "Judul",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "description",
      text: "Deskripsi",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "member.name",
      text: "Member",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "type",
      text: "Tipe",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.StatusFormatter,
    },
    {
      dataField: "image_url",
      text: "Image",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return cell ? (
          <OverlayTrigger
            overlay={
              <Tooltip id="tooltip-top">Click For Detail Image!</Tooltip>
            }
          >
            <div style={{ height: "85px", width: "145px" }}>
              <img
                style={{ objectFit: "contain", cursor: "pointer" }}
                src={row.image_url}
                alt="Product Image"
                width="100%"
                height="100%"
                onClick={() => {
                  setCurrentImages(row.image_url);
                }}
                className="shadow rounded"
                object
              />
            </div>
          </OverlayTrigger>
        ) : null;
      },
      // sortCaret: sortCaret,
      // headerSortingClasses,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditNotification: notificationUIProps.openEditNotification,
        // openDeleteNotificationDialog: notificationUIProps.openDeleteNotificationDialog,
        showModal: setShowModal,
        id: setRowId,
        allowDelete,
        allowUpdate,
        resendFunction,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: notificationUIProps.queryParams.page_size,
    page: notificationUIProps.queryParams.page_number,
  };
  return (
    <>
      <ImagesModal
        show={showModalImage}
        images={currentImages}
        onHide={() => setCurrentImages(null)}
      />

      <NotificationDisableDialog
        show={showModal}
        onHide={() => setShowModal(false)}
        id={rowId}
      />
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading || loading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  notificationUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: notificationUIProps.ids,
                //   setIds: notificationUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
